import createRoute      from '@widesk-ui/tools/createRoute';
import ClientGroupModel from '@models/shop/ClientGroupModel';

export default createRoute.dashboard('/client_groups', 'shop', 'ClientGroupDashboard', ClientGroupModel.localize());
